export default __webpack_public_path__ + "static/media/IconFacebook.1e4fe952.svg";